<template>
    <div class="card">
        <div class="container-fluid">
            <button type="button" @click="addSettingModal" class="btn btn-primary contct-b pull-left"><i class="fa fa-life-bouy"></i> Add {{this.$route.name}}</button>
            <!--            <form class="form-inline contct my-2 my-lg-0 pull-right">-->
            <!--                <select  @change="customerVisa(search.customer_id)" name="Customer" v-model="search.customer_id"  class="form-control" >-->
            <!--                    <option value="" >Select Client</option>-->
            <!--                    <option   :value="contact.id"  v-for="(contact,index) in allContacts" :key="index">{{contact.name}}</option>-->
            <!--                </select>-->
            <!-- <select name="CustomerVisa" v-model="search.visa_id"  class="form-control" >
                <option value="" >Select Visa</option>
                <option   :value="customervisa.id"  v-for="(customervisa,index) in customervisas" :key="index">{{customervisa.worker_number}}</option>
            </select> -->
            <!-- <select v-model="search.purpose"  class="form-control" style="margin-right:10px">
                <option value="" >Select Account Type</option>
                <option v-if="index == 0" disabled style="font-weight:800" v-for="(accountType,index) in getAccountType" :key="index+1000">{{accountType.name.toUpperCase()}}</option>
                <option v-if="purpose.account_type_id == 15"  v-for="(purpose,index) in purposes" :key="index+2000" :value="purpose.id">{{purpose.name}}</option>
                <option v-if="index == 1" disabled style="font-weight:800"  v-for="(accountType,index) in getAccountType" :key="index+3000">{{accountType.name.toUpperCase()}}</option>
                <option v-if="purpose.account_type_id == 16"  v-for="(purpose,index) in purposes" :key="index+4000" :value="purpose.id">{{purpose.name}}</option>
            </select> -->
            <!--                <button @click.prevent="searchIncome" class="btn btn-outline-success my-2 my-sm-0" >Search</button>-->
            <!--            </form>-->
            <table class="table table-sm">
                <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Water Billing Charge</th>
                    <th scope="col">Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(settingList,index) in settingLists" :key="index">
                    <td>{{ settingList.id }}</td>
                    <td>{{settingList.water_billing_charge}}</td>
                    <td>
                        <i @click="editSettingModal(settingList,index)" class="icon-note icons actn"> </i>
<!--                        <i @click="viewInvoiceModal(invoice)" class="icon-eye icons   actn"> </i>-->
                        <i @click="deleteSettingModal(index,settingList.id)" class="icon-trash icons   actn"> </i>
                    </td>
                </tr>
                </tbody>
            </table>
            <!--            <nav aria-label="Page navigation example">-->
            <!--                <pagination :data="Object.assign({},invoices2)" @pagination-change-page="getResults" :limit="8"></pagination>-->
            <!--            </nav>-->
        </div>
        <addSetting ref="add_setting_modal"></addSetting>
        <editSettingModal ref="edit_setting_modal"></editSettingModal>
        <Loader v-if="loading"></Loader>
    </div>
</template>

<script>
    import Loader from '../common/Loader'
    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
    import addSetting from './addSetting'
    import editSettingModal from './editSettingModal'
    Vue.use(VeeValidate);
    import { mapState,mapGetters } from "vuex"
    import { VueEditor } from 'vue2-editor'
    export default {
        name: "setting",
        data(){
            return{
                loading:false
            }
        },
        computed:{
            ...mapGetters(['settingLists','modal'])
        },
        mounted(){
            this.SettingList()
        },
        methods:{
            addSettingModal(){
                this.$refs.add_setting_modal.openModal()
            },
            SettingList(){
                this.$store.dispatch('SETTING_LIST')
            },
            editSettingModal(setting,index){
                this.$refs.edit_setting_modal.openModal(setting,index)
            },
            deleteSettingModal(index,id){
                this.$store.dispatch('DELETE_SETTING',{index,id})
            }
        },
        components: {
            addSetting,
            editSettingModal,
            Loader
        }
    }
</script>

<style scoped>

</style>